import { isTysonOrg } from './isTysonOrg';
import { portalForHostname } from './portalExperience';
import domains from '../config/portalDomains.json';

export const TYSON_LOGIN_PATH = domains.tyson.legacyLoginPath;
export const TYSON_RECOVERY_PATH = domains.tyson.legacyRecoveryPath;

const RETURN_EXPERIENCE_KEY = 'ipm:auth-experience';

function storedUser() {
    try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch (_) { return null; }
}

function storedExperience() {
    try {
        const value = JSON.parse(localStorage.getItem(RETURN_EXPERIENCE_KEY) || 'null');
        return ['ipm', 'tyson-engage'].includes(value?.experience) ? value : null;
    } catch (_) { return null; }
}

function sessionIdentity(user) {
    return user?.user && typeof user.user === 'object' ? { ...user, ...user.user } : user;
}

function accountId(user) {
    return String(user?._id || user?.id || user?.email || '');
}

function organisationExperience(user) {
    const kitId = String(user?.whiteLabel?.kitId || user?.brandKit?.id || '').toLowerCase();
    if (kitId && kitId !== 'custom') return kitId === 'tyson' ? 'tyson-engage' : 'ipm';
    if (user?.brand) return isTysonOrg(user) ? 'tyson-engage' : 'ipm';
    // Match the existing brand-kit precedence: a surname must not rebrand Mzansi.
    if (String(user?.agencyName || '').toLowerCase().includes('mzansi')) return 'ipm';
    return isTysonOrg(user) ? 'tyson-engage' : null;
}

/** Only successful sign-in/account updates remember a return page; visiting it does not. */
export function rememberLoginExperience(user, experience) {
    const identity = sessionIdentity(user);
    if (!identity) return;
    const previous = storedExperience();
    const sameAccount = accountId(identity) && previous?.accountId === accountId(identity);
    const resolved = organisationExperience(identity) || experience
        || (sameAccount ? previous?.experience : null) || 'ipm';
    try {
        // This contains only a display preference and account ID, never credentials.
        localStorage.setItem(RETURN_EXPERIENCE_KEY, JSON.stringify({ experience: resolved, accountId: accountId(identity) }));
    } catch (_) { /* A display preference must not prevent sign-in. */ }
}

export function loginPathForSession(user = storedUser()) {
    const portal = portalForHostname();
    if (portal) return portal.loginPath;
    const identity = sessionIdentity(user);
    const remembered = storedExperience();
    if (identity) {
        const organisation = organisationExperience(identity);
        if (organisation) return organisation === 'tyson-engage' ? TYSON_LOGIN_PATH : '/login';
        if (accountId(identity) && remembered?.accountId === accountId(identity) && remembered.experience === 'tyson-engage') return TYSON_LOGIN_PATH;
        return '/login';
    }
    return remembered?.experience === 'tyson-engage' ? TYSON_LOGIN_PATH : '/login';
}

/** Resolve before clearing so legacy Tyson sessions and concurrent 401s keep their brand. */
export function logoutToLogin({ fallback = '/' } = {}) {
    const user = storedUser();
    const loginPath = loginPathForSession(user);
    if (user) rememberLoginExperience(user);
    localStorage.removeItem('user');
    if (portalForHostname() || loginPath === TYSON_LOGIN_PATH) return loginPath;
    return fallback;
}
